/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_S3_L4Inputs */

const en_landing_guide_s3_l4 = /** @type {(inputs: Landing_Guide_S3_L4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Localisation: translate the text on a sign or a banner and keep its style, size and position.`)
};

const zh_landing_guide_s3_l4 = /** @type {(inputs: Landing_Guide_S3_L4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本地化：翻译招牌或横幅上的文字，同时保留字体风格、大小和位置。`)
};

/**
* | output |
* | --- |
* | "Localisation: translate the text on a sign or a banner and keep its style, size and position." |
*
* @param {Landing_Guide_S3_L4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_s3_l4 = /** @type {((inputs?: Landing_Guide_S3_L4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_S3_L4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_s3_l4(inputs)
	return zh_landing_guide_s3_l4(inputs)
});
export { landing_guide_s3_l4 as "landing.guide.s3_l4" }